<template>
    <div>
        <van-swipe class="goods-swipe" :autoplay="3000">
        <van-swipe-item v-for="item in data.images" :key="item.id">
            <img :src="item.img_url" >
        </van-swipe-item>
        </van-swipe>

        <van-cell-group>
        <van-cell>
            <div class="goods-title">{{ data.prod_name }}</div>
            <div class="goods-price">{{ '¥' + Number(data.shop_price).toFixed(2) }}</div>
        </van-cell>
        <van-cell class="goods-express" :title="data.brand_name"/>
        </van-cell-group>

        <van-cell-group class="goods-cell-group">
        <!-- <van-cell title="版本" :value="curversion.name" is-link @click="showPickVersion=true"/> -->
        <van-cell title="规格" :value="data.spc" />
        <van-cell title="条码" :value="data.barcode" />
        </van-cell-group>

        <van-collapse v-model="actionContent">
        <van-collapse-item title="使用车型" name="1">
            <van-list>
            <van-cell
                v-for="item in data.adapters" 
                :key="item.i"
                :title="item.n"/>
            </van-list>
        </van-collapse-item>
        <van-collapse-item title="用途" name="2">
            <van-list>
                <van-cell
                v-for="item in data.purposes" 
                :key="item.id"
                :title="item.name"/>
            </van-list>
        </van-collapse-item>
        <van-collapse-item title="属性" name="3">
            <van-list>
            <van-cell
                v-for="item in data.attributes" 
                :key="item.i"
                :title="item.property_name"
                :value="item.value_name"/>
            </van-list>
        </van-collapse-item>
        </van-collapse>
    </div>
</template>

<script>
// import { DirectSellApi } from '@/api/directsell'
// import { refreshAssert } from '@/utils/assert'

import {
  Tag,
  Col,
  Icon,
  Cell,
  CellGroup,
  Swipe,
  Collapse,
  CollapseItem,
  List,
  Panel,
  NavBar,
  SwipeItem,
  ActionSheet,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  // Toast
} from 'vant';

export default {
  name: 'ProdSpc',
  components: {
    [Tag.name]: Tag,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Swipe.name]: Swipe,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [List.name]: List,
    [Panel.name]: Panel,
    [SwipeItem.name]: SwipeItem,
    [NavBar.name]: NavBar,
    [ActionSheet.name]: ActionSheet,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionIcon.name]: GoodsActionIcon,
    [GoodsActionButton.name]: GoodsActionButton 
  },

  data() {
    return {
    //   data: {
    //     prod_name: '',
    //     brand_name: '',
    //     spc: '',
    //     cls_name: '',
    //     cls1_name: '',
    //     barcode: '',
    //     shop_price: '',
    //     rem: '',
    //     images: [],
    //     imgs: [], // 直销的图片说明
    //     versionprices: [],
    //     purposes: [],
    //     attributes: [],
    //     adapters: [],
    //     prod1_id: null,
    //     cls: null,
    //     cls1: null,
    //     qty: 1
    //   },
      actionContent: ['0'], // 显示规格等
      id: this.$route.params.id,
      showPickVersion: false,
      cartNum: 0, // 购物车数量
      curversion: {
        id: null,
        name: '',
        price: null,
        cost: null,
        img: null,
        url: null
      }, // 当前版本
      addSuccess: false,
      lunbo: []
    };
  },
  props: ['data'],
  mounted() {
    console.log(this.$router)
    // this.getData()
    // refreshAssert()
  },
  methods: {
    // getData() {
    //   var that = this
    //   this.axios.get(DirectSellApi + '/' + that.id + '/').then(function (ret) {
    //     console.log(ret)
    //     that.data.prod_name = ret.car_products_name
    //     that.data.brand_name = ret.brand_name
    //     that.data.spc = ret.car_products_spc
    //     that.data.cls_name = ret.cls_name
    //     that.data.cls1_name = ret.cls1_name
    //     that.data.cls = ret.cls
    //     that.data.prod1_id = ret.prod1_id
    //     that.data.prod_id = ret.prod_id
    //     that.data.cls1 = ret.cls1
    //     that.data.barcode = ret.barcode
    //     that.data.shop_price = ret.shop_price
    //     that.data.rem = ret.rem
    //     that.data.images = ret.imagetext_values
    //     that.data.imgs = ret.imgs
    //     that.data.versionprices = ret.versionprice
    //     that.data.purposes = ret.purpose_values
    //     that.data.attributes = ret.attribute
    //     that.data.adapters = ret.adapter_values

    //     if (that.data.versionprices.length > 0) {
    //       that.curversion = that.data.versionprices[0]
    //     }
    //   }).catch(function (error) {
    //     console.log(error)
    //   })
    // },
    // pickVersion(item) {
    //   console.log(item)
    //   this.curversion = item
    //   this.showPickVersion = false
    // },
    // buyNow() {
    //   console.log('begin')
    //   const data = {
    //     version_id: this.curversion.id,
    //     version_name: this.curversion.name,
    //     prd1_id: this.data.prod1_id,
    //     prd_name: this.data.prod_name,
    //     prd_spc: this.data.spc,
    //     prd_barcode: this.data.barcode,
    //     cls: this.data.cls,
    //     cls1: this.data.cls1,
    //     cls_name: this.data.cls_name,
    //     cls1_name: this.data.cls1_name,
    //     brand_name: this.data.brand_name,
    //     qty: this.data.qty,
    //     shop_price: this.data.shop_price,
    //     img: this.curversion.url
    //   }

    //   console.log('end')
    //   this.$router.push({
    //     name: 'nt/directsell/order', // 确定下单
    //     query: JSON.stringify(data)
    //   })
    //   console.log(JSON.stringify(data))
    //   console.log('end1')
    // },
    // onClickLeft() {
    //   this.$router.back(-1)
    // }
  }
};
</script>

<style lang="less">
.goods {
  padding-bottom: 50px;

  &-swipe {
    img {
      width: 100%;
      display: block;
    }
  }

  &-title {
    font-size: 16px;
  }

  &-price {
    color: #f44;
  }

  &-express {
    color: #999;
    font-size: 12px;
    padding: 5px 15px;
  }

  &-cell-group {
    margin: 15px 0;

    .van-cell__value {
      color: #999;
    }
  }

  &-tag {
    margin-left: 5px;
  }
}
</style>
